import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { PluginService } from '../../../plugins/services/plugin.service';
import { TenantUserPlugin } from '../plugins/tenant-user/tenant-user.plugin';
import { PluginDataInterface } from '../../../plugins/interfaces/plugin-data.interface';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { ChassisFormHandler } from '../../../forms/form/classes/form-handler';
import { TenantModel } from '../../../authentication/models/tenant.model';
import { TenantService } from '../../../authentication/services/tenant.service';
import { RouteService } from '../../../routing/services/route.service';
import { ToastService } from '../../../toast/services/toast.service';

@Component({
    selector: 'chassis-tenants-edit-page',
    templateUrl: './edit.page.html',
    styleUrls: ['./edit.page.scss'],
    providers: [TenantService]
})
export class TenantEditPage implements OnInit, OnDestroy {
    /**
     * The mode of the page that is being shown
     *
     * Available ptions:
     * create
     * edit
     * show (?)
     *
     * @type {string}
     */
    protected pageMode = 'edit';

    /**
     * The singular form of the model
     *
     * @type {string}
     */
    protected singular = 'tenant';

    /**
     * The plural form of the model
     *
     * @type {string}
     */
    protected plural = 'tenants';

    /**
     * The title of the page
     *
     * @type {string}
     */
    protected title = this.pageMode + ' ' + this.singular;

    /**
     * The route prefix for the buttons
     *
     * @type {string}
     */
    protected routePrefix = this.plural;

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'chassis-core-tenant-edit';

    /**
     * The ChassisFormHandler form instance.
     */
    public form: ChassisFormHandler;

    /**
     * The TenantModel instance.
     *
     * @type {TenantModel}
     */
    public model: TenantModel;

    /**
     * The TenantService instance.
     */
    protected tenantService: TenantService;

    /**
     * The RouteService instance.
     */
    protected routeService: RouteService;

    /**
     * The ActivatedRoute instance.
     */
    protected activatedRoute: ActivatedRoute;

    /**
     * The PluginService instance.
     */
    protected pluginService: PluginService;

    /**
     * The ToastService instance.
     */
    protected toastService: ToastService;

    /**
     * The subject which determines when the tenant is loaded.
     */
    protected tenantSubject: ReplaySubject<any>;

    protected authService: AuthenticationService;

    /**
     * The data to send to the plugin slots
     */
    protected pluginData: PluginDataInterface;

    /**
     * Constructor.
     *
     * @param {Injector} injector
     */
    constructor(protected injector: Injector) {

        this.tenantService  = this.injector.get(TenantService);
        this.routeService   = this.injector.get(RouteService);
        this.activatedRoute = this.injector.get(ActivatedRoute);
        this.pluginService  = this.injector.get(PluginService);
        this.toastService   = this.injector.get(ToastService);
        this.authService    = this.injector.get(AuthenticationService);

    }

    ngOnInit() {
        this.tenantSubject = new ReplaySubject(1);

        this.createForm();
        this.setupPlugins();

        this.activatedRoute.params.subscribe(
            (params: Params) => {

                this.authService.user().subscribe((user) => {

                    let tenantId;

                    if (!params['tenant']) {
                        console.log('no tenant param found', user.tenant_scope, user);
                        tenantId = user.tenant_scope;
                    } else {
                        console.log('tenant param found');
                        tenantId = params['tenant'];
                    }

                    this.tenantService.one(tenantId).subscribe((tenant: TenantModel) => {
                        this.model      = tenant;
                        this.form.model = this.model;

                        this.tenantSubject.next(this.model);
                        this.tenantSubject.complete();
                    });

                });
            }, (error) => {
                this.toastService.error('error', error);
            }
        );
    }

    /**
     * Create the form.
     */
    protected createForm() {
        this.model = this.tenantService.make();

        this.form = new ChassisFormHandler(this.injector, 'tenant', this.model);
    }

    /**
     * Add plugins to the page
     */
    protected setupPlugins() {
        this.pluginData = {
            inputs: {
                observable: this.tenantSubject,
                form: this.form,
                model: this.tenantSubject,
                modelSubject: this.tenantSubject
            }
        };

        // TODO: quick and dirty solution, should be moved to core.module.ts
        if (!this.pluginService.slot(this.pluginPrefix + '-sidebar').get('tenant-user')) {
            this.pluginService.add(this.pluginPrefix + '-sidebar', 'tenant-user', TenantUserPlugin, 0);
        }
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/tenants/edit/edit.page.ts